import { FC } from 'react';
import { Slide, ToastContainer as ToastifyContainer } from 'react-toastify';
import { mergeClasses } from 'shared/utils/mergeClasses';

export const ToastContainer: FC<{ topbarHidden: boolean }> = ({ topbarHidden }) => {
  return (
    <ToastifyContainer
      hideProgressBar
      closeButton={false}
      transition={Slide}
      className={mergeClasses(
        'right-0 gap-2 transition-all',
        topbarHidden ? 'top-4 md:top-17' : 'top-16 md:top-17',
      )}
      draggable={false}
      toastStyle={{
        alignItems: 'stretch',
        width: 'auto',
        padding: 0,
        margin: 0,
      }}
      style={{
        zIndex: 50,
      }}
    />
  );
};
